import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "audio"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "audio-name"
};
const _hoisted_6 = {
  key: 0,
  class: "audio-location"
};
const _hoisted_7 = {
  class: "number"
};
const _hoisted_8 = {
  class: "audio-menuv2"
};
const _hoisted_9 = ["onClick", "innerHTML"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 0,
  ref: "audioItem"
};
const _hoisted_12 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audioItem ${_ctx.$route.query.fid == 152288 ? 'nxbwgAudioItem' : ''}`)
  }, [_createElementVNode("div", {
    class: _normalizeClass(`audio-box ${$props.audioType == 2 ? 'audioBox2' : ''}`)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.audioList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_1, [item.littleImage ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "img-cover",
      onClick: $event => $options.getAudioDetail(item)
    }, [_createElementVNode("img", {
      class: "audio-img no-save-img",
      src: $options.getImg(item.littleImage, 236, 248)
    }, null, 8, _hoisted_3)], 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: _normalizeClass(["audio-desc", {
        'widthfixed': item.littleImage
      }])
    }, [_createElementVNode("div", {
      class: "desctop",
      onClick: $event => $options.getAudioDetail(item)
    }, [_createElementVNode("div", _hoisted_5, _toDisplayString($props.language ? item.en_antiqueName : item.antiqueName), 1), item.exhibitionLocation ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[0] || (_cache[0] = _createElementVNode("i", {
      class: "icon-address"
    }, null, -1)), _createElementVNode("span", _hoisted_7, _toDisplayString(item.exhibitionLocation), 1)])) : _createCommentVNode("", true)], 8, _hoisted_4), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
      class: "duration",
      onClick: $event => $options.getAudioDetail(item),
      innerHTML: item.desc
    }, null, 8, _hoisted_9), item.audioPath ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: $event => $options.clickPlay(index, item),
      class: "play"
    }, [_createElementVNode("i", {
      class: _normalizeClass($data.isPlaying && $data.currentIndex === index ? 'icon-pause' : 'icon-video1')
    }, null, 2)], 8, _hoisted_10)) : _createCommentVNode("", true)])], 2)]);
  }), 256))], 2), $data.audioPath ? (_openBlock(), _createElementBlock("audio", _hoisted_11, [_createElementVNode("source", {
    src: $data.audioPath,
    type: "audio/mpeg"
  }, null, 8, _hoisted_12)], 512)) : _createCommentVNode("", true)], 2);
}